import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import {OkHtmlDialogController} from '../../../core/dialog/OkHtmlDialogController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import {TSBemerkungScope} from '../../../models/enums/TSBemerkungScope';
import {TSRole} from '../../../models/enums/TSRole';
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import TSSchadenfall from '../../../models/TSSchadenfall';
import DVBernUtil from '../../../utils/DVBernUtil';
import AbstractModelManagerController from '../abstractModelManagerController';

declare let require: any;
declare let angular: any;

import IFormController = angular.IFormController;
import IQService = angular.IQService;
import IScope = angular.IScope;

const template = require('./bankkontoView.html');
const okHtmlDialogTempl = require('../../../core/dialog/okHtmlDialogTemplate.html');

export class BankkontoViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BankkontoViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        schadenfall: '<',
    };
}

export class BankkontoViewController extends AbstractModelManagerController<TSSchadenfall> {
    static $inject = [
        'DvDialog',
        'DVBernUtil',
        'SchadenfallModelManager',
        '$q',
        '$scope',
        '$state',
    ];
    schadenfall: TSSchadenfall;
    form: IFormController;
    scopeToShow: Array<TSBemerkungScope> = [];
    scope: TSBemerkungScope = TSBemerkungScope.BEMERKUNG_VIEW;

    /* @ngInject */
    constructor(private dvDialog: DvDialog, private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService, $scope: IScope, private $state: IStateService,
    ) {
        super(schadenfallModelManager, $scope, $state.current.name);
    }

    $onInit() {
        super.$onInit();
        if (!this.schadenfall) {
            console.error('no schadenfall passed to view');
        } else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
        }
    }

    public getViewTitle(): string {
        return this.dvBernUtil.getViewTitle(this.schadenfall);
    }

    public isShowTitlePrefix(): boolean {
        return this.dvBernUtil.isShowTitlePrefix(this.schadenfall.gesuchsteller);
    }

    public getRolesAllowedForBankdaten(): Array<TSRole> {
        return this.dvBernUtil.getRolesAllowedForBankdaten();
    }

    public saveBankverbindung(): void {
        if (this.isModelValid() && this.model) {

            if (this.model.status === TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN || this.model.status === TSSchadenfallStatus.AUSZAHLUNG) {
                this.dvDialog.showDialog(okHtmlDialogTempl, OkHtmlDialogController, {
                    title: '',
                    text: 'BEITRAG_SCHON_ERFASST',
                }).then(() => {
                    this.save();
                });
            } else {
                this.save();
            }
        }
    }

    private save() {
        const response = this.schadenfallModelManager.saveBankverbindung(this.model);
        this.form.$setPristine();
        this.form.$setUntouched();
        if (response) {
            response.then(() => this.navigateBack());
        }
    }

    public cancel() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.navigateBack();
    }

    private navigateBack() {
        let params: any = {schadenfallId: this.schadenfall.id};
        this.$state.go('aufwaende', params);
    }
}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/bankkontoView/bankkontoView.ts